import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"

export const LayerType = {
  Koku: "kouku",
  Gyoseikai: "gyouseikai",
  RoadGrid: "roadgrid",
}

export const LayerName = {
  Koku: "工区界",
  Gyoseikai: "行政界",
  RoadGrid: "道路図郭",
}

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
}

const MapControlLayerSelector = (props) => {
  return (
    <Box sx={{ ...styles.root, ...props.sx }}>
      <label>
        <input
          type="radio"
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(null)}
        />
        なし
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Koku}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.Koku)}
        />
        {LayerName.Koku}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Gyoseikai}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.Gyoseikai)}
        />
        {LayerName.Gyoseikai}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.roadGrid}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.RoadGrid)}
        />
        {LayerName.RoadGrid}
      </label>
    </Box>
  )
}

MapControlLayerSelector.propTypes = {
  onChange: PropTypes.func,
  sx: PropTypes.object,
}

export default MapControlLayerSelector
